import { Header } from '../components/Header';
import { NotFound } from '../components/NotFound';
import { Footer } from '../components/Footer';
export function NotFoundPage() {
  return (
    <>
      <Header />
      <NotFound />
      <Footer />
    </>
  );
}
